<template>
  <div class="app-container">
    <div class="container">
      <header>
        <h1>YT-Fun Player</h1>
        <div class="header-controls">
          <button class="connection-btn connect" @click="connect" v-if="isConnected == false">
            <img :src="require('@/assets/header/Disconnected.png')" class="usb-icon">
            <span>Connect Device</span>
            <div class="pulse-dot"></div>
          </button>
          <button class="connection-btn disconnect" @click="disconnect" v-if="isConnected">
            <img :src="require('@/assets/header/Connected.png')" class="usb-icon">
            <span>Connected</span>
            <div class="status-indicator"></div>
          </button>
        </div>
      </header>

      <div class="search-section">
        <div class="search-container">
          <input
            type="text"
            id="search-input"
            v-model="searchQuery"
            placeholder="Search YouTube videos or enter video ID/URL..."
            @keypress.enter="searchVideo"
          >
          <button id="search-button" @click="searchVideo">
            <span>Submit</span>
          </button>
        </div>
        <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
        <div class="loading" v-if="loadingMessage">{{ loadingMessage }}</div>
      </div>

      <div class="player-container">
        <div class="video-section">
          <div class="video-wrapper">
            <div id="youtube-player"></div>
            <div class="fallback-message" v-if="showFallback">
              <p>Player loading...</p>
              <button @click="retryInitialization" style="margin-top: 10px;">Retry Loading</button>
            </div>
          </div>

          <div class="controls">
            <div class="control-group">

              <!--              <button id="prev" :disabled="!isPlayerReady" @click="playPrevVideo">-->
              <!--                <span>Previous</span>-->
              <!--              </button>-->

              <button @click="triggerScriptFileInput">
                <span>Select Funscripts</span>
              </button>

              <button id="play-pause" :disabled="!isPlayerReady" @click="togglePlayPause">
                <!--                <span>{{ isPlaying ? 'Pause' : 'Play' }}</span>-->

                <i class="el-icon-video-pause" v-if="isPlaying" style="font-size: 20px"></i>
                <i class="el-icon-video-play" v-else style="font-size: 20px"></i>

              </button>

              <!--              <button id="next" :disabled="!isPlayerReady" @click="playNextVideo">-->
              <!--                <span>Next</span>-->
              <!--              </button>-->
            </div>

            <div class="progress-container">
              <div class="progress-bar" id="progress-bar" @click="seekToTime">
                <div class="progress" :style="{ width: progressPercent + '%' }"></div>
              </div>
              <div class="time-display">{{ currentTimeFormatted }} / {{ durationFormatted }}</div>
            </div>

            <div class="control-group">
              <div class="volume-container">
                <span>🔊</span>
                <input
                  type="range"
                  class="volume-slider"
                  id="volume-slider"
                  min="0"
                  max="100"
                  v-model="volume"
                  :disabled="!isPlayerReady"
                >
              </div>
              <button id="fullscreen" :disabled="!isPlayerReady" @click="toggleFullscreen">
                <i class="el-icon-full-screen"></i>
              </button>
            </div>
          </div>
          <div class="status">{{ statusMessage }}</div>
        </div>

        <!--        <div class="playlist-section">-->
        <!--&lt;!&ndash;          <h2 class="playlist-title">Playlist</h2>&ndash;&gt;-->
        <!--          <ul class="playlist">-->
        <!--            <li-->
        <!--              v-for="(video, index) in playlist"-->
        <!--              :key="index"-->
        <!--              class="playlist-item"-->
        <!--              :class="{ active: index === currentVideoIndex }"-->
        <!--              @click="playVideo(index)"-->
        <!--            >-->
        <!--              <img-->
        <!--                class="thumbnail"-->
        <!--                :src="`https://img.youtube.com/vi/${video.id}/default.jpg`"-->
        <!--                :alt="video.title"-->
        <!--                @error="handleImageError"-->
        <!--              >-->
        <!--              <div class="video-info">-->
        <!--                <div class="video-title">{{ video.title }}</div>-->
        <!--                <div class="video-duration">{{ video.duration }}</div>-->
        <!--              </div>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </div>-->
      </div>


      <!-- Simplified script file management area -->
      <!--      <div class="script-section">-->
      <!--        <h3>Script File Management</h3>-->
      <!--        <div class="file-controls">-->
      <!--          <button class="script-btn" @click="triggerScriptFileInput">-->
      <!--            <span>Select Script File</span>-->
      <!--          </button>-->

      <!--          <button-->
      <!--            class="script-btn clear-btn"-->
      <!--            @click="clearAllScripts"-->
      <!--            :disabled="scriptFiles.length === 0"-->
      <!--          >-->
      <!--            <span>Clear All Scripts</span>-->
      <!--          </button>-->
      <!--        </div>-->

      <!-- Hidden file input -->
      <input
        type="file"
        multiple
        accept=".funscript,.txt,.json,.mbscript"
        @change="handleScriptFileChange"
        ref="scriptFileInput"
        style="display: none"
      />

      <!-- Simple file list -->
      <div class="file-list" v-if="scriptFiles.length > 0">
        <div class="file-list-title">Selected Files ({{ scriptFiles.length }})</div>
        <div class="file-items">
          <div
            v-for="(file, index) in scriptFiles"
            :key="file.name + index"
            class="file-item"
          >
            <span class="file-name">{{ file.name }}</span>
            <span class="file-device">{{ getDeviceName(file.name) }}</span>
            <button class="remove-file" @click="removeScriptFile(index)">×</button>
          </div>
        </div>
      </div>

      <!-- Prompt when no files -->
      <div class="no-files" v-else>
        <p>No script files selected, please click the button above to select files</p>
      </div>
    </div>


  </div>
  </div>
</template>

<script>
import {TCodeFunScriptPlayer} from "@/tcode/TCodeFunScriptPlayer";

export default {
  name: 'YouTubePlayer',
  data() {
    return {
      scriptFiles: [], // Store selected script files
      funScriptPlayer: TCodeFunScriptPlayer.getInstance(),
      HOME: "L05050S1000 L15050S1000 L25050S1000 R05050S1000 R15050S1000 R25050S1000 V00000S1000 V10000S1000 V20000S1000 V30000S1000 A05050S1000 A15050S1000 A20000S1000 A35050S1000",
      //Output serial port
      mapJ: new Map(),

      isConnected: false,
      conInfo: '',
      player: null,
      currentVideoIndex: 0,
      isPlaying: false,
      isPlayerReady: false,
      initializationAttempts: 0,
      MAX_INIT_ATTEMPTS: 3,
      progressInterval: null,
      searchQuery: '',
      errorMessage: '',
      loadingMessage: 'Loading YouTube player...',
      showFallback: false,
      statusMessage: 'Initializing player...',
      volume: 50,
      currentTime: 0,
      duration: 0,
      progressPercent: 0,

      playlist: [
        {id: 'eQwEp9R0JnI', title: 'Dance Demo', duration: '1:00'},
        // {id: '9bZkp7q19f0', title: 'PSY - GANGNAM STYLE', duration: '4:13'},
        // {id: 'kJQP7kiw5Fk', title: 'Luis Fonsi - Despacito ft. Daddy Yankee', duration: '4:42'},
        // {id: 'JGwWNGJdvx8', title: 'Ed Sheeran - Shape of You', duration: '3:54'},
        // {id: '60ItHLz5WEA', title: 'Alan Walker - Faded', duration: '3:32'}
      ]
    };
  },
  computed: {
    currentTimeFormatted() {
      return this.formatTime(this.currentTime);
    },
    durationFormatted() {
      return this.formatTime(this.duration);
    }
  },
  mounted() {
    // Set global callback function
    window.onYouTubeIframeAPIReady = () => {
      console.log('YouTube API loaded successfully - from global callback');
      this.updateStatus('YouTube API loaded, initializing player...');
      this.initializePlayer();
    };

    this.initializeApp();

    setTimeout(() => {
      if (!this.isPlayerReady) {
        console.log('Player initialization timeout');
        this.showError('Player initialization timeout, please refresh the page or click the retry button');
        this.showFallback = true;
      }
    }, 10000);


    // Listen for data reception
    this.$serialPort.on('data-received', (data) => {
      console.log(".");
    });
    // Listen for connection status changes
    this.$serialPort.on('connection-change', ({isConnected}) => {
      this.isConnected = isConnected;
      this.conInfo = this.$serialPort.getPortInfo();
      if (this.isConnected == true) {
        this.send(this.HOME)
      }
    });

  },
  beforeDestroy() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    // Clean up global callback
    window.onYouTubeIframeAPIReady = null;
  },

  // 在生命周期钩子中
  created() {
    document.title = 'YT-Fun Player'
  },

  methods: {
    // Trigger file selection
    triggerScriptFileInput() {
      this.$refs.scriptFileInput.click();
    },
    // Handle file selection - fixed here
    async handleScriptFileChange(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;
      // console.log('Selected files:', files);
      // Use Vue.set or direct assignment to ensure reactive update
      for (const file of files) {
        // Check if file with same name already exists
        const exists = this.scriptFiles.some(f =>
          f.name === file.name && f.size === file.size
        );
        if (!exists) {
          // Use push method to ensure reactive update
          this.scriptFiles.push(file);
          await this.processScriptFile(file);
        }
      }
      // console.log('Updated file list:', this.scriptFiles);
      // Reset input value to allow selecting same files again
      event.target.value = null;
      // Add to player
      if (this.mapJ.size > 0) {
        this.funScriptPlayer.addScript(this.mapJ, 1, 10);
        // console.log('Script added to player');
      }
    },

    // Process single script file
    async processScriptFile(file) {
      try {
        const content = await this.readFileContent(file);
        const deviceName = this.getDeviceFromFileName(file.name);

        console.log(`Processing file: ${file.name}, device type: ${deviceName}`);
        const jsonContent = JSON.parse(content);
        // Process encrypted content
        if (jsonContent.mb == 'V2') {
          // console.log('Encrypted script detected, starting decryption...');
          const decrypted = this.decrypt(jsonContent.actionData, 'mdfuntion');
          jsonContent.actions = JSON.parse(decrypted);
          jsonContent.actionData = '';
        }
        this.mapJ.set(deviceName, jsonContent);
        // console.log(deviceName + ":" + JSON.stringify(jsonContent));
        // console.log(`Script file "${file.name}" loaded to device ${deviceName}`);
      } catch (error) {
        console.error(`Error processing script file ${file.name}:`, error);
      }
    },

    // Get device name from file name
    getDeviceFromFileName(fileName) {
      const name = fileName.toLowerCase();
      if (name.includes('.l0.')) return 'L0';
      if (name.includes('.l1.')) return 'L1';
      if (name.includes('.l2.')) return 'L2';
      if (name.includes('.r0.')) return 'R0';
      if (name.includes('.r1.')) return 'R1';
      if (name.includes('.r2.')) return 'R2';

      if (name.includes('.sway.')) return 'L2';
      if (name.includes('.surge.')) return 'L1';
      if (name.includes('.roll.')) return 'R1';
      if (name.includes('.pitch.')) return 'R2';
      if (name.includes('.twist.')) return 'R0';
      return 'L0';
    },

    // Get device display name
    getDeviceName(fileName) {
      const device = this.getDeviceFromFileName(fileName);
      const deviceNames = {
        'L0': 'L0', 'L1': 'L1', 'L2': 'L2',
        'R0': 'R0', 'R1': 'R1', 'R2': 'R2'
      };
      return deviceNames[device] || device;
    },

    // Remove single script file
    removeScriptFile(index) {
      const file = this.scriptFiles[index];
      const deviceName = this.getDeviceFromFileName(file.name);

      console.log(`Removing file: ${file.name}`);

      // Use splice to ensure reactive update
      this.scriptFiles.splice(index, 1);
      this.mapJ.delete(deviceName);

      console.log('File list after removal:', this.scriptFiles);
    },

    // Clear all scripts
    clearAllScripts() {
      console.log('Clearing all script files');
      this.scriptFiles = [];
      this.mapJ.clear();
    },

    // Read file content
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          console.log(`File ${file.name} read successfully`);
          resolve(event.target.result);
        };
        reader.onerror = (error) => {
          console.error(`Failed to read file ${file.name}:`, error);
          reject(error);
        };
        reader.readAsText(file);
      });
    },

    // Decryption function
    decrypt(encryptedText, key) {
      try {
        const decoded = decodeURIComponent(escape(atob(encryptedText)));
        return this.xorCrypt(decoded, key);
      } catch (error) {
        console.error('Decryption failed:', error);
        return encryptedText; // Return original text if decryption fails
      }
    },

    xorCrypt(str, key) {
      let result = '';
      const keyLength = key.length;
      for (let i = 0; i < str.length; i++) {
        const keyChar = key.charCodeAt(i % keyLength);
        const strChar = str.charCodeAt(i);
        result += String.fromCharCode(strChar ^ keyChar);
      }
      return result;
    },

    async send(data) {
      if (data.trim()) {
        try {
          // console.log("---------send:", data)
          await this.$serialPort.send(data);
        } catch (error) {
        }
      }
    },

    async connect() {
      try {
        await this.$serialPort.connect();
      } catch (error) {
        if (error.name === 'NotFoundError') {
          // User cancelled the port selection
          //this.$message({type: "info", message:"serial port selection cancelled"});
        } else {
          this.$message({type: "error", message: error.message});
          console.error('Connection failed:', error);
        }
      }
    },
    async disconnect() {
      try {
        this.isConnected = false;
        await this.$serialPort.disconnect();
      } catch (error) {
        console.error('Disconnect failed:', error);
      }
    },

    initializeApp() {
      console.log('Starting app initialization...');
      this.updateStatus('Loading YouTube Player API...');

      // Check if YouTube API is already loaded
      if (window.YT && YT.Player) {
        console.log('YouTube API already exists, initializing player directly');
        this.initializePlayer();
      } else {
        console.log('Loading YouTube API...');
        this.loadYouTubeAPI();
      }
    },

    loadYouTubeAPI() {
      // Check if already loaded
      if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        console.log('YouTube API script already exists, waiting for callback');
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.onerror = () => {
        console.error('YouTube API loading failed');
        this.showError('YouTube API loading failed, please check network connection');
        this.loadingMessage = '';
        this.showFallback = true;
      };

      document.head.appendChild(script);
      console.log('YouTube API script added');
    },

    initializePlayer() {
      if (this.initializationAttempts >= this.MAX_INIT_ATTEMPTS) {
        this.showError('Player initialization failed, please refresh the page and try again');
        return;
      }

      this.initializationAttempts++;
      console.log(`Player initialization attempt ${this.initializationAttempts}/${this.MAX_INIT_ATTEMPTS}`);

      // Ensure DOM element exists
      if (!document.getElementById('youtube-player')) {
        console.error('Player container element not found');
        setTimeout(() => this.initializePlayer(), 1000);
        return;
      }

      try {
        this.updateStatus('Creating player instance...');

        // Use simplest configuration to ensure playback
        this.player = new YT.Player('youtube-player', {
          height: '100%',
          width: '100%',
          videoId: this.playlist[0].id,
          playerVars: {
            'playsinline': 1,
            'controls': 0,           // Hide YouTube native controls
            'rel': 0,                // Don't show related videos
            'modestbranding': 1,     // Minimize brand display
            'enablejsapi': 1,        // Enable JS API
            'origin': window.location.origin,
            'iv_load_policy': 3,     // 隐藏注释
            'autohide': 1,           // 自动隐藏控件
            'disablekb': 1,          // 禁用键盘控制
          },
          events: {
            'onReady': this.onPlayerReady,
            'onStateChange': this.onPlayerStateChange,
            'onError': this.onPlayerError
          }
        });

        console.log('Player instance created successfully');

      } catch (error) {
        console.error('Player initialization error:', error);
        this.showError('Player initialization failed: ' + error.message);

        if (this.initializationAttempts < this.MAX_INIT_ATTEMPTS) {
          setTimeout(() => this.initializePlayer(), 2000);
        } else {
          this.showFallback = true;
        }
      }
    },

    retryInitialization() {
      this.initializationAttempts = 0;
      this.showFallback = false;
      this.loadingMessage = 'Loading YouTube player...';
      this.errorMessage = '';

      // Reset global callback
      window.onYouTubeIframeAPIReady = () => {
        console.log('YouTube API loaded successfully - retry callback');
        this.updateStatus('YouTube API loaded, initializing player...');
        this.initializePlayer();
      };

      this.loadYouTubeAPI();
    },

    onPlayerError(event) {
      console.error('Player error:', event.data);
      let errorMessage = 'Video playback error: ';
      switch (event.data) {
        case 2:
          errorMessage += 'Invalid video ID parameter';
          break;
        case 5:
          errorMessage += 'HTML5 player error';
          break;
        case 100:
          errorMessage += 'Video does not exist or has been deleted';
          break;
        case 101:
        case 150:
          errorMessage += 'Video not allowed to be embedded';
          break;
        case 153:
          errorMessage += 'Player configuration error';
          break;
        default:
          errorMessage += 'Unknown error (' + event.data + ')';
      }

      this.showError(errorMessage);

      setTimeout(() => {
        this.playNextVideo();
      }, 2000);
    },

    showError(message) {
      this.errorMessage = message;
      this.loadingMessage = '';

      setTimeout(() => {
        this.errorMessage = '';
      }, 5000);
    },

    onPlayerReady(event) {
      console.log('Player ready!');
      this.isPlayerReady = true;
      this.updateStatus('Player ready');

      this.player.setVolume(this.volume);

      this.progressInterval = setInterval(this.updateProgress, 500);

      this.loadingMessage = '';
      this.showFallback = false;

      // Force resize after video is ready
      this.$nextTick(() => {
        this.adjustPlayerSize();
      });
    },

    // Adjust player size
    adjustPlayerSize() {
      const iframe = document.querySelector('#youtube-player iframe');
      if (iframe) {
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        console.log('Player size adjusted');
      }
    },

    onPlayerStateChange(event) {
      if (!this.isPlayerReady) return;

      console.log('Player state changed:', event.data);

      switch (event.data) {
        case YT.PlayerState.PLAYING:
          if (!this.canPlayVideo()) {
            this.player.pauseVideo();
            this.canPlayVideo();
            return;
          }
          this.runScript();
          this.isPlaying = true;
          this.updateStatus('Playing: ' + this.getCurrentVideoTitle());
          this.errorMessage = '';
          break;
        case YT.PlayerState.PAUSED:
          this.funScriptPlayer.stop();
          this.isPlaying = false;
          this.updateStatus('Paused');
          this.canPlayVideo();
          break;
        case YT.PlayerState.ENDED:
          this.isPlaying = false;
          // this.playNextVideo();
          break;
        case YT.PlayerState.BUFFERING:
          this.updateStatus('Buffering...');
          break;
        case YT.PlayerState.CUED:
          this.updateStatus('Video loaded successfully');
          break;
      }
    },


    canPlayVideo() {
      if (this.isConnected == false) {
        this.updateStatus('Please connect device first...');
        return false;
      }
      if (this.scriptFiles == null || this.scriptFiles.length <= 0) {
        this.updateStatus('Please select script...');
        return false;
      }
      return true;
    },

    async runScript() {
      let currentTimeMs = 0;
      // Safely get current time
      try {
        const currentTimeSeconds = this.player.getCurrentTime();
        currentTimeMs = Math.round(currentTimeSeconds * 1000);
        console.log(`Starting playback, current time: ${currentTimeSeconds} seconds (${currentTimeMs} milliseconds)`);
      } catch (timeError) {
        console.warn('Unable to get current playback time, using 0 as start time:', timeError);
        currentTimeMs = 0;
      }
      this.funScriptPlayer.setSendCommandCallback(this.send);
      this.funScriptPlayer.stop();
      await this.funScriptPlayer.runScript(currentTimeMs, false);
    },

    playVideo(index) {
      if (!this.isPlayerReady || !this.player) {
        this.showError('Player not ready yet');
        return;
      }
      if (index >= 0 && index < this.playlist.length) {
        this.currentVideoIndex = index;
        try {
          if (this.player.loadVideoById) {
            this.player.loadVideoById(this.playlist[index].id);
            this.updateStatus('Loading video...');

            // Adjust size after video loads
            setTimeout(() => {
              this.adjustPlayerSize();
            }, 500);
          } else {
            this.showError('Player method unavailable, please refresh the page and try again');
          }
        } catch (error) {
          console.error('Play video error:', error);
          this.showError('Failed to play video: ' + error.message);
        }
      }
    },
    playNextVideo() {
      const nextIndex = (this.currentVideoIndex + 1) % this.playlist.length;
      this.playVideo(nextIndex);
    },
    playPrevVideo() {
      const prevIndex = (this.currentVideoIndex - 1 + this.playlist.length) % this.playlist.length;
      this.playVideo(prevIndex);
    },

    getCurrentVideoTitle() {
      return this.playlist[this.currentVideoIndex].title;
    },

    togglePlayPause() {
      if (!this.isPlayerReady || !this.player) return;
      try {
        if (this.isPlaying) {
          this.player.pauseVideo();
          this.funScriptPlayer.stop();
        } else {
          if (this.canPlayVideo() == false) {
            return;
          }
          this.player.playVideo();

        }
      } catch (error) {
        console.error('Playback control error:', error);
        this.showError('Playback control failed: ' + error.message);
      }
    },

    updateProgress() {
      if (!this.isPlayerReady || !this.player || !this.player.getCurrentTime) return;

      try {
        const currentTime = this.player.getCurrentTime();
        const duration = this.player.getDuration();

        if (duration > 0) {
          const progressPercent = (currentTime / duration) * 100;
          this.progressPercent = progressPercent;
          this.currentTime = currentTime;
          this.duration = duration;
        }
      } catch (error) {
        console.error('Update progress error:', error);
      }
    },

    seekToTime(e) {
      if (!this.isPlayerReady || !this.player || !this.player.getDuration) return;

      try {
        const rect = e.currentTarget.getBoundingClientRect();
        const percent = (e.clientX - rect.left) / rect.width;
        const newTime = this.player.getDuration() * percent;
        // Convert to milliseconds
        const newTimeMs = Math.round(newTime * 1000);
        this.player.seekTo(newTime, true);

        // If playing, sync script time
        if (this.isPlaying) {
          this.funScriptPlayer.stop();
          this.funScriptPlayer.runScript(newTimeMs, false);
        }
        console.log(`Seek to: ${newTime} seconds (${newTimeMs} milliseconds)`);

      } catch (error) {
        console.error('Progress control error:', error);
      }
    },

    toggleFullscreen() {
      const videoWrapper = document.querySelector('.video-wrapper');
      if (!videoWrapper) return;

      if (!document.fullscreenElement) {
        // Enter fullscreen
        if (videoWrapper.requestFullscreen) {
          videoWrapper.requestFullscreen();
        } else if (videoWrapper.webkitRequestFullscreen) {
          videoWrapper.webkitRequestFullscreen();
        } else if (videoWrapper.mozRequestFullScreen) {
          videoWrapper.mozRequestFullScreen();
        } else if (videoWrapper.msRequestFullscreen) {
          videoWrapper.msRequestFullscreen();
        }
      } else {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },

    searchVideo() {
      const query = this.searchQuery.trim();

      if (!query) return;

      if (!this.isPlayerReady) {
        this.showError('Player not ready yet');
        return;
      }


      // 添加Shorts检测日志
      // console.log('是否包含shorts:', query.includes('shorts'));
      // console.log('是否包含youtube.com/shorts/:', query.includes('youtube.com/shorts/'));
      // console.log('是否包含/shorts/:', query.includes('/shorts/'));

      let videoId = null;

      // Parse YouTube URL or ID
      if (query.includes('youtube.com') || query.includes('youtu.be')) {
        try {
          const url = new URL(query);
          console.log(url)
          if (query.includes('youtube.com')) {
            videoId = url.searchParams.get('v');
          } else if (query.includes('youtu.be')) {
            videoId = url.pathname.substring(1);
          }
          if (videoId == null) {
            if (query.includes('youtube.com/shorts/')) {
              // alert(query)
              console.log(url.pathname)
              const pathParts = url.pathname.split('/');
              console.log(pathParts)
              if (pathParts.length >= 3 && pathParts[1] === 'shorts') {
                videoId = pathParts[2];
                // alert(videoId)
              }
            }
          }
          // alert(videoId);
        } catch (error) {
          console.error('URL parsing error:', error);
          this.showError('Invalid YouTube URL');
          return;
        }
      }

      if (videoId == null) {
        videoId = query;
      }

      if (videoId && videoId.length === 11) {
        // Add to playlist
        this.playlist.unshift({
          id: videoId,
          title: 'Newly added video - ' + videoId,
          duration: 'Unknown'
        });

        this.currentVideoIndex = 0;

        try {
          if (this.player.loadVideoById) {
            // Key modification: use cueVideoById instead of loadVideoById
            this.player.cueVideoById(videoId);
            this.updateStatus('Video loaded, click play button to start');
            this.searchQuery = '';

            // Adjust size after video loads
            setTimeout(() => {
              this.adjustPlayerSize();
            }, 500);
          } else {
            this.showError('Player method unavailable');
          }
        } catch (error) {
          console.error('Load video error:', error);
          this.showError('Failed to load video: ' + error.message);
        }
      } else {
        this.showError('Invalid YouTube video ID');
      }
    },

    formatTime(seconds) {
      const min = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${min}:${sec < 10 ? '0' : ''}${sec}`;
    },

    updateStatus(message) {
      this.statusMessage = message;
    },

    handleImageError(event) {
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA2MCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjQ1IiBmaWxsPSIjMzMzMzMzIi8+Cjx0ZXh0IHg9IjMwIiB5PSIyMi41IiBmaWxsPSJ3aGl0ZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5ObyBJbWFnZTwvdGV4dD4KPC9zdmc+';
    }
  },
  watch: {
    volume(newVolume) {
      if (this.isPlayerReady && this.player) {
        this.player.setVolume(newVolume);
      }
    },
    scriptFiles: {
      handler(newVal) {
        console.log('File list changed:', newVal);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
/* 外层容器确保背景覆盖整个屏幕 */
.app-container {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.container {
  background: transparent;
  color: #fff;
  min-height: 100vh;
  padding: 15px; /* 减小容器内边距 */
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px; /* 减小元素间距 */
}

/* 头部布局调整 */
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  position: relative;
}

.header-controls {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* 连接按钮全新设计 */
.connection-btn {
  border: none;
  border-radius: 12px;
  padding: 12px 20px;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15),
  inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

/* 连接状态 - 科技蓝配色 */
.connection-btn.connect {
  background: linear-gradient(135deg,
  rgba(74, 144, 226, 0.9) 0%,
  rgba(41, 98, 255, 0.9) 100%);
  border: 1px solid rgba(116, 172, 255, 0.3);
}

.connection-btn.connect:hover {
  background: linear-gradient(135deg,
  rgba(94, 164, 246, 0.9) 0%,
  rgba(61, 118, 255, 0.9) 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(41, 98, 255, 0.3),
  inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

/* 断开状态 - 活力橙配色 */
.connection-btn.disconnect {
  background: linear-gradient(135deg,
  rgba(76, 175, 80, 0.9) 0%,
  rgba(56, 142, 60, 0.9) 100%);
  border: 1px solid rgba(129, 199, 132, 0.3);
}

.connection-btn.disconnect:hover {
  background: linear-gradient(135deg,
  rgba(96, 195, 100, 0.9) 0%,
  rgba(76, 162, 80, 0.9) 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3),
  inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.connection-btn:active {
  transform: translateY(0);
}

/* USB图标样式 */
.usb-icon {
  width: 18px;
  height: 18px;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.connection-btn:hover .usb-icon {
  transform: scale(1.1);
}

/* 脉冲动画 - 连接状态 */
.pulse-dot {
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  margin-left: 5px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(0.8);
    opacity: 1;
  }
}

/* 状态指示器 - 断开状态 */
.status-indicator {
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  margin-left: 5px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

/* 按钮点击涟漪效果 */
.connection-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.3s, height 0.3s;
}

.connection-btn:active::after {
  width: 100px;
  height: 100px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .header-controls {
    position: static;
    transform: none;
  }

  .connection-btn {
    padding: 10px 16px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .connection-btn {
    padding: 8px 14px;
    font-size: 0.8rem;
    gap: 8px;
  }

  .usb-icon {
    width: 16px;
    height: 16px;
  }

  .pulse-dot,
  .status-indicator {
    width: 6px;
    height: 6px;
  }
}

h1 {
  font-size: 2rem; /* 减小标题字体 */
  margin-bottom: 8px; /* 减小标题下边距 */
  background: linear-gradient(90deg, #ff8a00, #e52e71);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.subtitle {
  font-size: 1rem; /* 减小副标题字体 */
  color: #a0a0c0;
}

.search-section {
  background: rgba(30, 30, 50, 0.8);
  border-radius: 10px; /* 减小圆角 */
  padding: 15px; /* 减小内边距 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.search-container {
  display: flex;
  gap: 8px; /* 减小搜索框和按钮间距 */
}

#search-input {
  flex: 1;
  padding: 10px 12px; /* 减小输入框内边距 */
  border: none;
  border-radius: 50px;
  background: rgba(40, 40, 60, 0.8);
  color: white;
  font-size: 0.9rem; /* 减小字体 */
  outline: none;
}

#search-input::placeholder {
  color: #a0a0c0;
}

#search-button {
  padding: 10px 20px; /* 减小按钮内边距 */
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  font-size: 0.9rem; /* 减小字体 */
}

#search-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

.error-message {
  text-align: center;
  padding: 12px; /* 减小内边距 */
  background: rgba(220, 53, 69, 0.2);
  border-radius: 8px;
  margin-top: 8px; /* 减小上边距 */
  color: #ff6b6b;
  font-size: 0.9rem; /* 减小字体 */
}

.loading {
  text-align: center;
  padding: 12px; /* 减小内边距 */
  color: #6a11cb;
  font-size: 0.9rem; /* 减小字体 */
}

.player-container {
  display: flex;
  flex-direction: column;
  gap: 15px; /* 减小间距 */
}

@media (min-width: 768px) {
  .player-container {
    flex-direction: row;
    gap: 15px; /* 减小间距 */
  }
}

.video-section {
  flex: 3;
  display: flex;
  flex-direction: column;
  gap: 12px; /* 减小间距 */
}

/* 视频容器 - 减小高度 */
.video-wrapper {
  position: relative;
  width: 100%;
  height: 520px; /* 减小高度 */
  background-color: #000;
  border-radius: 10px; /* 减小圆角 */
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

/* 在大屏幕上使用适中的高度 */
@media (min-width: 768px) {
  .video-wrapper {
    height: 580px; /* 减小高度 */
  }
}

@media (min-width: 1024px) {
  .video-wrapper {
    height: 520px; /* 减小高度 */
  }
}

#youtube-player {
  width: 100%;
  height: 100%;
  border: none;
}

.fallback-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  font-size: 0.9rem; /* 减小字体 */
}

.controls {
  background: rgba(30, 30, 50, 0.8);
  padding: 12px; /* 减小内边距 */
  border-radius: 10px; /* 减小圆角 */
  display: flex;
  flex-wrap: wrap;
  gap: 8px; /* 减小控件间距 */
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.control-group {
  display: flex;
  gap: 8px; /* 减小按钮间距 */
  align-items: center;
}

button {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  border: none;
  padding: 6px 12px; /* 减小按钮内边距 */
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px; /* 减小图标和文字间距 */
  font-weight: 500;
  font-size: 0.85rem; /* 减小字体 */
}

button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none !important;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

button:active:not(:disabled) {
  transform: translateY(0);
}

.progress-container {
  flex: 1;
  min-width: 180px; /* 减小最小宽度 */
  display: flex;
  align-items: center;
  gap: 8px; /* 减小间距 */
}

.progress-bar {
  flex: 1;
  height: 5px; /* 减小进度条高度 */
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, #ff8a00, #e52e71);
  width: 0%;
  transition: width 0.1s;
}

.time-display {
  font-size: 0.8rem; /* 减小字体 */
  color: #a0a0c0;
  min-width: 90px; /* 减小最小宽度 */
  text-align: center;
}

.volume-container {
  display: flex;
  align-items: center;
  gap: 6px; /* 减小间距 */
}

.volume-slider {
  width: 70px; /* 减小滑块宽度 */
  -webkit-appearance: none;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
}

.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 12px; /* 减小滑块拇指大小 */
  height: 12px;
  border-radius: 50%;
  background: #6a11cb;
  cursor: pointer;
}

.status {
  text-align: center;
  padding: 8px; /* 减小内边距 */
  font-style: italic;
  color: #a0a0c0;
  font-size: 0.85rem; /* 减小字体 */
}

.playlist-section {
  flex: 1;
  background: rgba(30, 30, 50, 0.8);
  border-radius: 10px; /* 减小圆角 */
  padding: 15px; /* 减小内边距 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-height: 500px; /* 减小最大高度 */
  overflow-y: auto;
}

.playlist-title {
  font-size: 1.3rem; /* 减小字体 */
  margin-bottom: 12px; /* 减小下边距 */
  padding-bottom: 8px; /* 减小内边距 */
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #e52e71;
}

.playlist {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px; /* 减小列表项间距 */
}

.playlist-item {
  padding: 10px 12px; /* 减小内边距 */
  background: rgba(40, 40, 60, 0.6);
  border-radius: 6px; /* 减小圆角 */
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px; /* 减小内容间距 */
}

.playlist-item:hover {
  background: rgba(60, 60, 90, 0.8);
  transform: translateX(3px); /* 减小悬停移动距离 */
}

.playlist-item.active {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3); /* 减小阴影 */
}

.thumbnail {
  width: 50px; /* 减小缩略图尺寸 */
  height: 38px; /* 减小缩略图尺寸 */
  border-radius: 4px;
  object-fit: cover;
}

.video-info {
  flex: 1;
}

.video-title {
  font-size: 0.85rem; /* 减小字体 */
  font-weight: 500;
  margin-bottom: 3px; /* 减小下边距 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3; /* 调整行高 */
}

.video-duration {
  font-size: 0.75rem; /* 减小字体 */
  color: #a0a0c0;
}

footer {
  text-align: center;
  padding: 15px 0; /* 减小内边距 */
  color: #a0a0c0;
  font-size: 0.8rem; /* 减小字体 */
  margin-top: 15px; /* 减小上边距 */
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* 响应式调整 */
@media (max-width: 767px) {
  .controls {
    flex-direction: column;
    align-items: stretch;
    gap: 10px; /* 减小间距 */
  }

  .control-group {
    justify-content: center;
    gap: 6px; /* 减小按钮间距 */
  }

  .progress-container {
    order: -1;
    width: 100%;
  }

  .video-wrapper {
    height: 250px; /* 减小移动端高度 */
  }

  .container {
    padding: 10px; /* 减小移动端内边距 */
    gap: 12px; /* 减小移动端间距 */
  }
}

@media (max-width: 480px) {
  .container {
    padding: 8px; /* 进一步减小内边距 */
  }

  h1 {
    font-size: 1.7rem; /* 减小移动端标题 */
  }

  .search-container {
    flex-direction: column;
    gap: 6px; /* 减小间距 */
  }

  .control-group {
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px; /* 减小按钮间距 */
  }

  .progress-container {
    min-width: auto;
  }

  .video-wrapper {
    height: 200px; /* 进一步减小高度 */
  }

  .playlist-section {
    max-height: 350px; /* 减小播放列表高度 */
    padding: 12px; /* 减小内边距 */
  }
}

/* 全屏样式 */
:fullscreen .video-wrapper {
  height: 100vh !important;
  width: 100vw !important;
  border-radius: 0 !important;
  max-width: none !important;
  max-height: none !important;
}

/* 脚本管理区域样式 */
.script-section {
  background: rgba(30, 30, 50, 0.8);
  border-radius: 10px;
  padding: 15px;
  margin-top: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.script-section h3 {
  color: #e52e71;
  margin-bottom: 12px;
  font-size: 1.1rem;
}

.file-controls {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.script-btn {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.script-btn.clear-btn {
  background: rgba(220, 53, 69, 0.8);
}

.script-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.script-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

/* 文件列表样式 */
.file-list {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 10px;
}

.file-list-title {
  font-size: 0.9rem;
  color: #a0a0c0;
  margin-bottom: 8px;
}

.file-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: rgba(40, 40, 60, 0.6);
  border-radius: 6px;
  font-size: 0.85rem;
  transition: all 0.3s ease;
}

.file-item:hover {
  background: rgba(50, 50, 70, 0.8);
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-device {
  background: rgba(106, 17, 203, 0.3);
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.75rem;
  margin: 0 8px;
  border: 1px solid rgba(106, 17, 203, 0.5);
}

.remove-file {
  background: rgba(220, 53, 69, 0.3);
  border: 1px solid rgba(220, 53, 69, 0.5);
  color: #ff6b6b;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  transition: all 0.3s ease;
}

.remove-file:hover {
  background: rgba(220, 53, 69, 0.6);
  transform: scale(1.1);
}

/* 没有文件时的提示 */
.no-files {
  text-align: center;
  padding: 20px;
  color: #a0a0c0;
  font-style: italic;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .file-controls {
    flex-direction: column;
  }

  .file-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .file-device {
    align-self: flex-start;
    margin: 0;
  }

  .remove-file {
    align-self: flex-end;
    margin-top: -25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/youtube/YouTubePlayer.vue